import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const TickMarkSVG = ({
  fill = 'currentColor',
  size = '12',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        d="M3.3858 10.774L0.425858 7.29996C0.290078 7.14078 0.182365 6.95177 0.108875 6.74372C0.0353847 6.53567 -0.00244141 6.31267 -0.00244141 6.08746C-0.00244141 5.86225 0.0353847 5.63925 0.108875 5.4312C0.182365 5.22315 0.290078 5.03414 0.425858 4.87496C0.700068 4.55369 1.07173 4.37325 1.45924 4.37325C1.84674 4.37325 2.21841 4.55369 2.49262 4.87496L4.34631 7.04796C4.38368 7.09156 4.43424 7.11604 4.48694 7.11604C4.53964 7.11604 4.59019 7.09156 4.62756 7.04796L9.43438 1.40796C9.70859 1.0867 10.0803 0.90625 10.4678 0.90625C10.8553 0.90625 11.2269 1.0867 11.5011 1.40796C11.6369 1.56714 11.7446 1.75615 11.8181 1.9642C11.8916 2.17225 11.9294 2.39525 11.9294 2.62046C11.9294 2.84567 11.8916 3.06867 11.8181 3.27672C11.7446 3.48477 11.6369 3.67378 11.5011 3.83296L5.58637 10.774C5.29453 11.1163 4.89875 11.3086 4.48609 11.3086C4.07342 11.3086 3.67764 11.1163 3.3858 10.774Z"
        fill={fill}
      />
    </svg>
  </span>
);

export default TickMarkSVG;
